import AppChannel from "../AppChannel";
import TrayItemModel from "./model/TrayItemModel";


export default class TrayBarChannel extends AppChannel {
    add(item) {
        let trayItemModel = new TrayItemModel(item);

        this.trigger("add", trayItemModel);

        return trayItemModel;
    }
}